import React from 'react'

// In V2 we use “real” buttons to open dropdowns, hence the use of the
// “sites-button” class.
export default function DropdownButton (props) {
  return <button className="sites-button">{props.children}</button>
}
